(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-hero"] && !window.DesignMode) return;
  try {
    
    class CollectionTabs extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.tabs = this.querySelectorAll('.collection-tab');
        this.contents = this.querySelectorAll('.collection-content');
        this.heroImages = document.querySelectorAll('.image-video-hero');
        this.tabsContainer = this.querySelector('.collection-tabs');
        
        // Set initial active tab width and position
        if (this.tabs.length > 0) {
          const firstTab = this.tabs[0];
          this.updateTabIndicator(firstTab);
        }

        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => this.switchTab(tab));
        });
      }

      updateTabIndicator(activeTab) {
        // Get the width and position of the active tab
        const tabRect = activeTab.getBoundingClientRect();
        const containerRect = this.tabsContainer.getBoundingClientRect();
        
        // Calculate width (subtract padding)
        const width = tabRect.width - 12; // 6px padding on each side
        
        // Calculate position relative to the container
        const position = activeTab.offsetLeft;
        
        // Update CSS variables
        this.tabsContainer.style.setProperty('--active-tab-width', `${width}px`);
        this.tabsContainer.style.setProperty('--active-tab-position', `${position}px`);
      }

      switchTab(selectedTab) {
        // Remove active class from all tabs, contents, and hero images
        this.tabs.forEach(tab => tab.classList.remove('active'));
        this.contents.forEach(content => content.classList.remove('active'));
        this.heroImages.forEach(hero => hero.classList.remove('active'));
        
        // Add active class to selected tab and corresponding content
        selectedTab.classList.add('active');
        const tabId = selectedTab.dataset.tab;
        
        const targetContent = this.querySelector(`#collection-${tabId}`);
        if (targetContent) {
          targetContent.classList.add('active');
        }

        // Add active class to corresponding hero image
        const targetHero = document.querySelector(`#hero-${tabId}`);
        if (targetHero) {
          targetHero.classList.add('active');
        }

        // Update the sliding indicator
        this.updateTabIndicator(selectedTab);
      }
    }

    if (!customElements.get('collection-tabs')) {
      customElements.define('collection-tabs', CollectionTabs);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-v2"] && !window.DesignMode) return;
  try {
    
    class CollectionTabs extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.tabs = this.querySelectorAll('.collection-tab');
        this.contents = this.querySelectorAll('.collection-content');
        this.tabsContainer = this.querySelector('.collection-tabs');
        
        // Set initial active tab width and position
        if (this.tabs.length > 0) {
          const firstTab = this.tabs[0];
          this.updateTabIndicator(firstTab);
        }

        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => this.switchTab(tab));
        });
      }

      updateTabIndicator(activeTab) {
        // Get the width and position of the active tab
        const tabRect = activeTab.getBoundingClientRect();
        const containerRect = this.tabsContainer.getBoundingClientRect();
        
        // Calculate width (subtract padding)
        const width = tabRect.width - 12; // 6px padding on each side
        
        // Calculate position relative to the container
        const position = activeTab.offsetLeft;
        
        // Update CSS variables
        this.tabsContainer.style.setProperty('--active-tab-width', `${width}px`);
        this.tabsContainer.style.setProperty('--active-tab-position', `${position}px`);
      }

      switchTab(selectedTab) {
        // Remove active class from all tabs and contents
        this.tabs.forEach(tab => tab.classList.remove('active'));
        this.contents.forEach(content => content.classList.remove('active'));
        
        // Add active class to selected tab and corresponding content
        selectedTab.classList.add('active');
        const targetContent = this.querySelector(`#collection-${selectedTab.dataset.tab}`);
        if (targetContent) {
          targetContent.classList.add('active');
        }

        // Update the sliding indicator
        this.updateTabIndicator(selectedTab);
      }
    }

    if (!customElements.get('collection-tabs')) {
      customElements.define('collection-tabs', CollectionTabs);
    }
  
  } catch(e) { console.error(e); }
})();
})();
